export default state => state.vod.hodor.requested;
